const EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
const PHONE_REGEX = /(^$)|(^([0]{2}|[+])?([0-9]{3})?[. \s]?(\d[ \s]?){9}$)/;
const NUMBER_REGEX = /^[0-9]*$/;
const POSTAL_CODE_REGEX = /^\d{3}\s?\d{2}$/;

const isValidTaxNumber = (taxNumber: string | undefined | null): boolean => {
  if (!taxNumber) {
    return false;
  }

  if (isNaN(parseInt(taxNumber))) {
    return false;
  }

  let a = 0;
  let c = 0;
  const b = taxNumber.split('');
  for (let i = 0; i < 7; i++) a += parseInt(b[i]) * (8 - i);
  a = a % 11;
  c = 11 - a;
  if (a == 1) c = 0;
  if (a == 0) c = 1;
  return parseInt(b[7]) === c;
};

export const validators = {
  email: EMAIL_REGEX,
  phone: PHONE_REGEX,
  taxNumber: isValidTaxNumber,
  number: NUMBER_REGEX,
  postalCode: POSTAL_CODE_REGEX,
};
